module.exports = __webpack_public_path__ + "media/images/img-realestate-8-e7c555f9.png";